import { NewsletterSplitTestViewApiInterface } from 'modules/newsletters/single/types/newsletter-view-interface'
import { MailingSplitTestWinnerTypeEnum } from 'modules/newsletters/split-test/enum/mailing-split-test-winner-type-enum'
import { SplitTestSettingsInterface } from 'modules/newsletters/split-test/types/newsletter-split-test-interface'
import { useEffect, useState } from 'react'

const setDefaultSplitTestSettings = (newsletterData: NewsletterSplitTestViewApiInterface) =>
  newsletterData.mailingSplitTest.settings ?? {
    // 8 days
    durationInHours: 192,
    emailRatio: 5,
    winnerType: MailingSplitTestWinnerTypeEnum.ClickRate,
  }

export const useSplitTestSettings = (newsletterData: NewsletterSplitTestViewApiInterface) => {
  const [splitTestSettings, setSplitTestSettings] = useState<SplitTestSettingsInterface>(
    setDefaultSplitTestSettings(newsletterData),
  )

  useEffect(() => {
    setSplitTestSettings(setDefaultSplitTestSettings(newsletterData))
  }, [newsletterData])

  return { splitTestSettings, setSplitTestSettings }
}
